import { Link } from 'react-router-dom';
import { Menu, MessageCircle, X } from 'lucide-react';

const NavLink = ({ item, onClick }) => {
  if (item.to) {
    return (
      <Link
        to={item.to}
        onClick={onClick}
        className="text-[11px] font-bold uppercase tracking-[0.2em] transition-colors hover:text-emerald-600"
      >
        {item.label}
      </Link>
    );
  }
  return (
    <a
      href={item.href}
      onClick={onClick}
      className="text-[11px] font-bold uppercase tracking-[0.2em] transition-colors hover:text-emerald-600"
    >
      {item.label}
    </a>
  );
};

const SiteHeader = ({ imgBase, isMenuOpen, setIsMenuOpen, scrolled, sections }) => {
  const close = () => setIsMenuOpen(false);

  return (
    <>
      <nav
        className={`fixed z-50 w-full transition-all duration-300 ${
          scrolled ? 'bg-white/95 py-5 shadow-sm backdrop-blur-md' : 'bg-transparent py-8'
        }`}
      >
        <div className="container mx-auto flex items-center justify-between px-6">
          <div className="flex items-center gap-4">
            <Link to="/" className="flex items-center gap-4" onClick={close}>
              <img
                src={`${imgBase}logo_banner.png`}
                alt="Richard Atik Logo"
                className="h-20 w-auto max-w-none shrink-0 object-contain sm:h-24 md:h-28 lg:h-32"
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
            </Link>
          </div>

          <div className="hidden items-center gap-8 md:flex">
            {sections.map((s) => (
              <NavLink key={s.label} item={s} />
            ))}
            <a
              href="https://wa.me/34670784860"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 rounded-full bg-slate-900 px-6 py-2.5 text-[11px] font-bold uppercase tracking-widest text-white transition-all hover:bg-emerald-700"
            >
              <MessageCircle size={14} /> Contactar
            </a>
          </div>

          <button type="button" className="p-2 text-slate-900 md:hidden" onClick={() => setIsMenuOpen(!isMenuOpen)}>
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </nav>

      {isMenuOpen && (
        <div className="fixed inset-0 z-40 flex flex-col items-center justify-center gap-8 bg-white p-6 text-center md:hidden">
          <Link to="/" onClick={close}>
            <img src={`${imgBase}logo_banner.png`} className="mb-8 h-64" alt="Logo" />
          </Link>
          {sections.map((s) =>
            s.to ? (
              <Link
                key={s.label}
                to={s.to}
                onClick={close}
                className="text-3xl font-black uppercase tracking-tighter text-slate-900 hover:text-emerald-600"
              >
                {s.label}
              </Link>
            ) : (
              <a
                key={s.label}
                href={s.href}
                onClick={close}
                className="text-3xl font-black uppercase tracking-tighter text-slate-900 hover:text-emerald-600"
              >
                {s.label}
              </a>
            )
          )}
          <a
            href="tel:+34670784860"
            className="mt-4 w-full rounded-2xl bg-slate-900 py-4 font-bold uppercase tracking-widest text-white"
          >
            Llamar Ahora
          </a>
        </div>
      )}
    </>
  );
};

export default SiteHeader;
